export default {
  "Audio Compressor": "Compressor de Áudio",
  "HitPaw Online Audio Compressor": "HitPaw Online Compressor de Áudio",
  "Reduce audio file size online without quality loss.": "Reduzir o tamanho do arquivo de áudio online sem perda de qualidade.",
  "Compress": "Comprimir",
  "Compressing": "Comprimindo",
  "Compressed Successfully": "Comprimido Com Sucesso",
  "Compress New": "Comprimir Novo",
  "Compression is complete": "A compressão está terminada",
  "Compression failed": "Falha em Comprimir",
  "Quality": "Qualidade",
  "Format": "Formato",
  "Add file": "Adicionar Arquivo",
  "Output Settings": "Configurações de Saída",

};
